import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";

import {
  GetSingleCashflow,
  reset,
} from "../../../features/cashflow/CashflowSlice";

import { GetAllKodeAkunDropdown } from "../../../features/KodeAkunSlice";

import { Card, Button, Form, Col, Row } from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import BASE_URL from "../../../api";
import { UserContext } from "../../../utils/ProtectedRoute";
import DatePickerComponent from "../../../components/DatePickerComponent";
import { formatNumber, removeFormatter, removeTrailingZero } from "../../../helpers/helper";

const FormCashflowPage = () => {
  const [dataCashflow, setDataCashflow] = useState({
    tanggal: new Date(),
  });

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.cashflow);

  const {
    data: dataFakultasList,
    isLoading: isLoadingFakultasList,
    isError: isErrorFakultasList,
  } = useSelector((state) => state.fakultas);

  const {
    data: dataProdiList,
    isLoading: isLoadingProdiList,
    isError: isErrorProdiList,
  } = useSelector((state) => state.prodi);

  const {
    data: dataKodeAkunList,
    isLoading: isLoadingKodeAkunList,
    isError: isErrorKodeAkunList,
  } = useSelector((state) => state.kodeAkun);

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  // on init (call once when the page has been loaded)
  useEffect(() => {
    // call api to fetch fakultas dropdown data
    dispatch(reset());
    dispatch(GetAllKodeAkunDropdown(token));
    if (id) {
      dispatch(GetSingleCashflow({ id, token }));
    }
  }, [id, dispatch, token]);

  // init the model before send to Server, if any.
  // update the model if user role is meant for "MAHASISWA".
  useEffect(() => {
    const copyData = Object.assign(
      { ...data?.data },
      {
        tanggal: data?.data?.tanggal ? new Date(data?.data?.tanggal) : new Date(),
        kredit: data?.data?.kredit,
        kreditMask: removeTrailingZero(data?.data?.kredit),
        debet: data?.data?.debet,
        debetMask: removeTrailingZero(data?.data?.debet),
      }
    );
    setDataCashflow(copyData);
  }, [data]);

  function getKodeAkunList() {
    try {
      const result = (dataKodeAkunList?.data || []).map((item, i) => ({
        value: item,
        label: `${item.row_num} - ${item.kode ? "[" + item.kode + "] " : ""}${
          item.name
        }`,
        isDisabled: item.kode === null,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(
              `${BASE_URL}cashflow/${id}`,
              {
                ...dataCashflow,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}cashflow`,
              {
                ...dataCashflow,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate("/cashflow/list");
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        {param.pathname.split("/")[2] === "detail" ? (
          <>
            <div className="d-block mb-4 mb-xl-0">
              <Header title="Detail Cashflow" />
            </div>
          </>
        ) : param.pathname.split("/")[2] === "create" ? (
          <>
            <div className="d-block mb-4 mb-xl-0">
              <Header title="Buat Cashflow" />
            </div>
          </>
        ) : param.pathname.split("/")[2] === "edit" ? (
          <>
            <div className="d-block mb-4 mb-xl-0">
              <Header title="Edit Cashflow" />
            </div>
          </>
        ) : null}
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          dataCashflow={dataCashflow}
          setDataCashflow={setDataCashflow}
          handleSubmit={handleSubmit}
          formDisable={param.pathname.split("/")[2] === "detail" ? true : false}
          isLoading={isLoading}
          isError={isError}
          // fakultas
          // isLoadingFakultasList={isLoadingFakultasList}
          // isErrorFakultasList={isErrorFakultasList}
          // dataFakultasList={getFakultasList()}
          // prodi
          // isLoadingProdiList={isLoadingProdiList}
          // isErrorProdiList={isErrorProdiList}
          // dataProdiList={dataProdiList}
          // kodePay
          isLoadingKodeAkunList={isLoadingKodeAkunList}
          isErrorKodeAkunList={isErrorKodeAkunList}
          dataKodeAkunList={getKodeAkunList()}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = (props) => {
  const {
    isLoading,
    isError,
    dataCashflow,
    setDataCashflow,
    id,
    handleSubmit,
    formDisable,
    // fakultas
    isLoadingFakultasList,
    isErrorFakultasList,
    dataFakultasList,
    // prodi
    isLoadingProdiList,
    isErrorProdiList,
    dataProdiList,
    // kode
    isLoadingKodeAkunList,
    isErrorKodeAkunList,
    dataKodeAkunList,
  } = props;

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            {isError ? "something error" : null}

            {/* TEMPORARY HIDE BECAUSE THE RULES STILL DIDN'T OBVIOUS */}
            {/* <Col md={12} className="mb-3">
              <Form.Group id="id_fakultas">
                <Form.Label>Fakultas</Form.Label>
                <Select
                  options={dataFakultasList}
                  placeholder="Pilih fakultas"
                  required
                  autoFocus
                  onChange={(e) => {
                    setDataCashflow({
                      ...dataCashflow,
                      id_fakultas: e.value.id,
                    })
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="id_prodi">
                <Form.Label>Prodi</Form.Label>
                <Select
                  options={dataProdiList}
                  placeholder="Pilih prodi"
                  required
                  autoFocus
                  isDisabled={formDisable}
                  onChange={(e) => {
                    setDataCashflow({
                      ...dataCashflow,
                      id_prodi: e.value.id,
                    })
                  }}
                />
              </Form.Group>
            </Col> */}

            <Col md={12} className="mb-3">
              <Form.Group id="kode">
                <Form.Label>
                  Kode Akun<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Select
                  options={dataKodeAkunList}
                  placeholder="Pilih kode akun"
                  value={dataKodeAkunList?.find(
                    (e) => e.value.kode === dataCashflow.kode
                  )}
                  required
                  isLoading={isLoadingKodeAkunList}
                  isDisabled={formDisable}
                  onChange={(e) => {
                    setDataCashflow({
                      ...dataCashflow,
                      kode: e.value.kode,
                      isDebet: e.value.isDebet,
                      // reset all
                      debet: 0,
                      debetMask: 0,
                      kredit: 0,
                      kreditMask: 0,
                    });
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group controlId="tanggal">
                <Form.Label>
                  Tanggal
                  <span style={{ color: "red" }}>
                    {props.mandatory ? "*" : ""}
                  </span>
                </Form.Label>
                <DatePickerComponent
                  mandatory={true}
                  formDisable={formDisable}
                  value={dataCashflow.tanggal}
                  onChange={(e) => {
                    setDataCashflow({
                      ...dataCashflow,
                      tanggal: e,
                    });
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="no_bukti">
                <Form.Label>No Bukti</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="-"
                  name="no_bukti"
                  disabled={formDisable}
                  value={dataCashflow.no_bukti || ""}
                  onChange={(e) =>
                    setDataCashflow({
                      ...dataCashflow,
                      no_bukti: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="keterangan">
                <Form.Label>Keterangan</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="-"
                  name="keterangan"
                  disabled={formDisable}
                  value={dataCashflow.keterangan || ""}
                  onChange={(e) =>
                    setDataCashflow({
                      ...dataCashflow,
                      keterangan: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            {dataCashflow.kode ? (
              dataCashflow.isDebet ? (
                <Col md={12} className="mb-3">
                  <Form.Group id="debet">
                    <Form.Label>
                      Masuk<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="0"
                      name="debet"
                      disabled={formDisable}
                      value={dataCashflow.debetMask || ""}
                      onChange={(e) =>
                        setDataCashflow({
                          ...dataCashflow,
                          debet: removeFormatter(e.target.value),
                          debetMask: formatNumber(e.target.value),
                        })
                      }
                    />
                  </Form.Group>
                </Col>
              ) : (
                <Col md={12} className="mb-3">
                  <Form.Group id="kredit">
                    <Form.Label>
                      Keluar<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="0"
                      name="kredit"
                      disabled={formDisable}
                      value={dataCashflow.kreditMask || ""}
                      onChange={(e) =>
                        setDataCashflow({
                          ...dataCashflow,
                          kredit: removeFormatter(e.target.value),
                          kreditMask: formatNumber(e.target.value),
                        })
                      }
                    />
                  </Form.Group>
                </Col>
              )
            ) : null}
            {formDisable && dataCashflow.nama_fakultas ? (
              <Col md={12} className="mb-3">
                <Form.Group id="nama_fakultas">
                  <Form.Label>Nama Fakultas</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="nama_fakultas"
                    disabled={true}
                    value={dataCashflow.nama_fakultas}
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable && dataCashflow.nama_user_buat ? (
              <Col md={12} className="mb-3">
                <Form.Group id="nama_user_buat">
                  <Form.Label>Nama User Buat</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="nama_user_buat"
                    disabled={true}
                    value={dataCashflow.nama_user_buat}
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable && dataCashflow.created_at ? (
              <Col md={12} className="mb-3">
                <Form.Group id="created_at">
                  <Form.Label>Tanggal Dibuat</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="created_at"
                    disabled={true}
                    value={moment(dataCashflow.created_at).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                  />
                </Form.Group>
              </Col>
            ) : null}
          </Row>
          {formDisable ? null : (
            <div>
              {id ? (
                <Button type="submit" disabled={isLoading}>
                  Update
                </Button>
              ) : (
                <Button type="submit" disabled={isLoading}>
                  Simpan
                </Button>
              )}
            </div>
          )}
        </Form>
      )}
    </Card.Body>
  );
};

export default FormCashflowPage;
